module.exports = __webpack_public_path__ + "img/山河医学网-方形.846dc48e.png";